import axios from 'axios';

export const getMifidExAnteCosts = async ({ body }) => axios.post(
    `${global?.AppConfig?.VKW_URL_SUFFIX}/v1/get-mifid-ex-ante-costs`,
    body,
);

export const postPseudoisin = async (body) => axios.post(
    `${global?.AppConfig?.DSL_URL_SUFFIX}/v1.0/allocation/pseudo-isin/search`,
    body,
);

export const postOrderBook = async ({ body }) => axios.post(
    `${global?.AppConfig?.VKW_URL_SUFFIX}/v1/get-order-book`,
    body,
);
